import React, { createContext, useCallback, useMemo } from "react";

export type ExperimentContextType = {
  flags: Record<string, number | string | boolean>;
  getValue: (flag: string) => string | number | boolean | undefined;
};

export const ExperimentContext = createContext({} as ExperimentContextType);

export const ExperimentProvider: React.FC<{
  children: React.ReactNode;
  flags: Record<string, number | string | boolean>;
}> = ({ children, flags }) => {
  const getFlag = useCallback(
    (flag) => {
      if (flags && flag in flags) {
        return flags[flag];
      }
      return undefined;
    },
    [flags]
  );

  const values = useMemo(
    () => ({
      flags,
      getValue: getFlag
    }),
    [flags, getFlag]
  );

  return (
    <ExperimentContext.Provider value={values}>
      {children}
    </ExperimentContext.Provider>
  );
};
